<template>
<div class="container-fluid">
  <div class="d-flex h-100 flex-column">
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-5">
        <TabContainer>

          <Tabs name="Veículos" v-if="showVehicles">
            <DashboardVehicle/>
          </Tabs>

          <Tabs name="Empresas" v-if="$canNew('application', 'companies/view')">
            <DashboardCompany/>
          </Tabs>

          <Tabs name="Usuários" v-if="$withPolicy('application', 'users')">
            <DashboardUser/>
          </Tabs>

          <Tabs name="Últimas ações" v-if="$withPolicy('application', 'events')">
            <DashboardEvent/>
          </Tabs>

        </TabContainer>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import TabContainer from '../shares/TabContainer'
  import Tabs from '../shares/Tab'
  import DashboardUser from '@/components/dashboard/DashboardUser'
  import DashboardCompany from '@/components/dashboard/DashboardCompany'
  import DashboardEvent from '@/components/dashboard/DashboardEvent'
  import DashboardVehicle from '@/components/dashboard/DashboardVehicle'
  import GetAccountApps from '@/mixins/GetAccountApps';
  import GetUser from '@/mixins/GetUser.vue';

  export default {
    components: { DashboardCompany, DashboardEvent, DashboardUser, DashboardVehicle, TabContainer, Tabs },
    computed: {
      showVehicles() {
        return this.$canNew('application', 'vehicles/view') &&
          this.getAccountApps.some(aa => aa.active && ['cm-frotas', 'cm-crono', 'cm-taxas'].includes(aa.name))
      }
    },
    mixins: [GetAccountApps, GetUser],
    name: 'General',
  }
</script>

<style scoped>
  p{
    color:  #051B30;
  }

  ul{
    margin: 5px;
  }

</style>
